import { Component, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { DataSource } from '@angular/cdk/collections';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';

import 'rxjs/add/operator/startWith';
import 'rxjs/add/operator/map';
import 'rxjs/add/observable/merge';
import 'rxjs/add/observable/fromEvent';
import 'rxjs/add/operator/distinctUntilChanged';
import 'rxjs/add/operator/debounceTime';

import { OpcionModel } from '../Global/Opcion.model';
import { FacturacionElectronicaReenviarFacturaModel } from './FacturacionElectronicaReenviarFactura.model';
import { ServiciosGenerales } from '../Servicios/ServiciosGenerales.service';
import { MatSnackBar } from '@angular/material';


@Component({
	selector: 'consultarPdf',
	templateUrl: './ReenviarFactura.component.html',
	styleUrls: ['../../../../styles.css']
})

/**
* @author Camilo
* @since  01/10/2018
**/
export class FacturacionElectronicaReenviarFacturaComponent {

	public form: FormGroup;
	public formErrors: any;

	public prefijo: string;
	public numero: string;
	public negocio: string;
	public mensaje: string = "";

	myControl = new FormControl();
	filteredOptions: Observable<OpcionModel[]>;
	

	public btnConsultar: boolean;
	public ocultar: boolean = false;

	
	


	constructor(private formBuilder: FormBuilder, private _serviciosGenerales: ServiciosGenerales, public snackBar: MatSnackBar,
		private _route: ActivatedRoute, private _router: Router, public dialog: MatDialog) {

		// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
		this.btnConsultar = _serviciosGenerales.seguridad.isConsultar();
		// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
		this.snackBar.dismiss();
	}


	ngOnInit() {
		this.inicializarForm();
	}


	inicializarForm() {
		this.formErrors = {
			prefijo: {},
			numero: {},
			negocio: {}
		};


		this.form = this.formBuilder.group({
			prefijo: ['', Validators.required],
			numero: ['', Validators.required],
			negocio: ['', Validators.required]
		});
	}




	onFormValuesChanged() {
		for (const field in this.formErrors) {
			if (!this.formErrors.hasOwnProperty(field)) {
				continue;
			}

			// Clear previous errors
			this.formErrors[field] = {};

			// Get the control
			const control = this.form.get(field);

			if (control && control.dirty && !control.valid) {
				this.formErrors[field] = control.errors;
			}
		}
	}

	openSnackBar(message: string, action: string) {
		let snackBarRef = this.snackBar.open(message, action);

		snackBarRef.onAction().subscribe(() => {
			console.log("Paso por aqui 1");

			this.ocultar = false;
			this.mensaje = "";
		});

		

	}
	openSnackBarEspecial(message: string, action: string) {
        let snackBarRef =  this.snackBar.open(message, action);
 
        snackBarRef.onAction().subscribe(() => {
           
            this.ocultar = false;
            this.mensaje = "";
        });
        
        let shand = document.getElementsByClassName('mat-snack-bar-container') as HTMLCollectionOf<HTMLElement>;        
        
        if (shand.length != 0) {
                for (let i=0;i<shand.length;i++){
                shand[i].style.backgroundColor = "rgb(255 204 214)";
                }
            }
    }

	consultar() {
		this.ocultar = true;
		this.mensaje = "Procesando...";

		var tipoempresa = JSON.parse(this._serviciosGenerales.seguridad.getInfoToken().ntipoempresa).ntipoempresa;

		this._serviciosGenerales.get('validarTipoEmpresaDocumentoEnviar', { prefijo: this.prefijo, negocio: this.negocio }).subscribe(
			result => {
				if (result[0].ntipoempresa !=tipoempresa) {
					//console.log("cantidad de registros sucursales " + result[0].cantidad);
					this.ocultar = true;
					this.mensaje = "Procesando Información ..";
					this.openSnackBarEspecial("El Documento " + this.prefijo+"-"+this.numero + " NO se puede enviar ya que no existe para este tipo de empresa.", "X");
					return;
				} 
				else{
					let parametros = { prefijo: this.prefijo, numeroFactura: this.numero, negocio: this.negocio };
					//this._serviciosGenerales.descargarArchivo('servicioFacturacionElectronica/generar/pdf', parametros);
					this._serviciosGenerales.get('servicioFacturacionElectronica/reenviarFactura', parametros).subscribe(
						result => {
							console.log('',result);
							if(result.error == false){
								this.openSnackBar("Proceso realizado con éxito", "X")
							}else{
								this.openSnackBarEspecial(result.mensaje, "X")
							}		
						}, error => {
							console.log(error);
							this.openSnackBarEspecial("Ocurrió un error al momento de enviar la petición al servidor de factur", "X")
						}
					)
				}
			}, error => {
				console.log("", error);

				this.ocultar = true;
				this.mensaje = "Procesando Información ..";

				this.openSnackBarEspecial("Ocurrió un error al momento de validar el Tipo Empresa", "X");
			});
	}
}





// WEBPACK FOOTER //
// D:/REPO/FacturacionWeb/src/app/main/content/FacturacionElectronicaReenviarFactura/FacturacionElectronicaReenviarFactura.component.ts